import Component from '../inherited/Component'

export default class LazyThirdParty extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._options = {...{
      scriptDelay: 10,
      styleDelay: 10,
      responsive: [
        {
          breakpoint: "834px",
          settings: {
            scriptDelay: 1600,
            styleDelay: 1600
          }
        }
      ]
    }, ...this._options}

    this._scriptTags = this._elem.querySelectorAll('script[data-lazy][data-src]')
    this._inlineScriptTags = this._elem.querySelectorAll('script[data-lazy]:not([data-src])')
    this._linkTags = this._elem.querySelectorAll('link[data-lazy]')
  }

  mount () {
    console.log(this._scriptTags)
    console.log(this._linkTags)

    window.addEventListener('load', e => {
      setTimeout(() => {
        this._lazyLoadScripts()
      }, this._options.scriptDelay)

      setTimeout(() => {
        this._lazyLoadStyles()
      }, this._options.styleDelay)
    })
  }

  async _lazyLoadScripts () {
    let promises = []

    for (let tag of this._scriptTags) {
      promises.push(new Promise((res, rej) => {
        this._lazyLoadScript(tag, () => {

          if (tag.dataset.lazy.length) {
            let inlineTags = this._elem.querySelectorAll(`script[data-lazy="${tag.dataset.lazy}"][type="text/plain"]`)

            for (let inlineTag of inlineTags) {
              this._lazyLoadScript(inlineTag)
            }
          }

          res()
        })

        
      }))
    }

    await Promise.all(promises)

    for (let tag of this._inlineScriptTags) {
      if (tag.dataset.lazy.length) continue

      this._lazyLoadScript(tag)
    }
  }

  _lazyLoadScript (tag, cb = null) {
     try {
      let script_tag = document.createElement('script')
      script_tag.type = 'text/javascript'

      if (tag.dataset.src) {
        script_tag.src = tag.dataset.src
      } else {
        script_tag.innerHTML = tag.innerHTML
      }

      if(cb) {
        script_tag.onload = cb
        script_tag.onerror = cb
      }

      document.head.appendChild(script_tag)

      tag.remove()
    } catch (e){
      console.error(e.message)
    }
  }

  _lazyLoadStyles () {
    for (let tag of this._linkTags) {
      let link_tag = document.createElement('link')
      link_tag.type = 'text/css'
      link_tag.rel = 'stylesheet'

      if (tag.dataset.src) {
        link_tag.src = tag.dataset.src
      } else {
        link_tag.text = tag.innerHTML
      }

      document.head.appendChild(link_tag);

      tag.remove()
    }
  }
}